<template>
  <div id="app">
    <div v-if="isloading" class="loading"></div>
    <notice></notice>
    <headers></headers>
    <router-view />
    <footers v-if="isinvitation"></footers>
    <div style="width: 100%;height: 35px;background: url('/static/img/footer_bg.png') center center/cover no-repeat;">

    </div>
  </div>
</template>
<script>
import Notice from "../../components/header/Notice.vue";
import headers from "../../components/header/header.vue";
import footers from "../../components/footer/footer.vue";
export default {
  name: "App",
  data() {
    return {};
  },
  components: {
    footers,
    headers,
    Notice
  },
  computed: {
    isloading: function() {
      return this.$store.state.isloading;
    },
    isinvitation: function() {
      return this.$store.state.isinvitation;
    }
  }
};
</script>

<style>
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -80px 0 0 -40px;
  width: 80px;
  height: 80px;
  border: 3px solid #d0d3d4;
  border-top-color: #626567;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
  z-index: 99999;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue